export const flightDataMapper = (isTwoWay, flightItem, flightSegment) => {
    return !!isTwoWay
        ? {
              airline: flightSegment?.[0]?.airline?.english,
              airlinePersian: flightSegment?.[0]?.airline?.persian,
              airlineLogo: flightSegment?.[0]?.airline?.image,
              departureDate: flightSegment?.[0]?.departure_date,
              departureEnName: flightSegment?.[0]?.departure?.city?.english,
              departureFaName: flightSegment?.[0]?.departure?.city?.persian,
              departureIata: flightSegment?.[0]?.departure?.terminal?.code,
              departureTerminal: flightSegment?.[0]?.departure?.terminal?.name,
              departureTime: flightSegment?.[0]?.departure_time,
              destinationTime: flightSegment?.[0]?.destination_time,
              arrivalDate: flightSegment?.[0]?.arrival_date,
              destinationEnName: flightSegment?.[0]?.destination?.city?.english,
              destinationFaName: flightSegment?.[0]?.destination?.city?.persian,
              destinationIata: flightSegment?.[0]?.destination?.terminal?.code,
              destinationTerminal: flightSegment?.[0]?.destination?.terminal?.name,
              type: flightItem?.type,
              persianType: flightItem?.persian_type,
              flightNumber: flightSegment?.[0]?.flight_number,
              cabin: flightItem?.cabin?.english,
              cabinPersian: flightItem?.cabin?.persian,
              aircraft: flightSegment?.[0]?.aircraft,
              baggage: flightSegment?.[0]?.baggage,
              class: flightSegment?.[0]?.fare_class,
              fareType: flightItem?.fares?.type,
              fareSourceCode: flightItem?.fare_source_code,
              childPrice: flightItem?.fares?.child?.price,
              adultPrice: flightItem?.fares?.adult?.price,
              infantPrice: flightItem?.fares?.infant?.price,
              totalPrice: flightItem?.fares?.total_price,
              capacity: "",
          }
        : {
              airline: flightItem?.airline,
              airlinePersian: flightItem?.airline_persian,
              airlineLogo: flightItem?.airline_logo,
              departureDate: flightItem?.departure_date,
              departureEnName: flightItem?.english_departure_name,
              departureFaName: flightItem?.departure_name,
              departureIata: flightItem?.departure,
              departureTerminal: flightItem?.departure_terminal,
              departureTime: flightItem?.departure_time,
              destinationTime: flightItem?.destination_time,
              arrivalDate: flightItem?.arrival_date,
              destinationEnName: flightItem?.english_destination_name,
              destinationFaName: flightItem?.destination_name,
              destinationIata: flightItem?.destination,
              destinationTerminal:flightItem?.destination_terminal,
              type: flightItem?.type,
              persianType: flightItem?.persian_type,
              flightNumber: flightItem?.flight_number,
              cabin: flightItem?.cobin,
              cabinPersian: flightItem?.cobin_persian,
              aircraft: flightItem?.aircraft,
              baggage: flightItem?.tag === "pr" ? flightItem?.baggage : `${flightItem?.baggage?.Quantity}${flightItem?.baggage?.Unit}`,
              class: flightItem?.class,
              fareType: flightItem?.fare_type,
              fareSourceCode: flightItem?.fare_source_code,
              childPrice: flightItem?.child_price,
              adultPrice: flightItem?.adult_price,
              infantPrice: flightItem?.infant_price,
              totalPrice: flightItem?.total_price,
              capacity: flightItem?.capacity,
          };
};
